export function convertComplexRoutes(routes) {
    var root = [];
    routes.forEach(function (route) {
        _convertComplexRoute(route, null, root, null);
    });
    root = root.filter(function (route) { return route.redirect ? true : (route.component ? true : false); });
    function sortRoutes(a, b) {
        var aPath = a.path ? a.path.length : 0;
        var bPath = b.path ? b.path.length : 0;
        if (aPath < bPath)
            return -1;
        if (aPath > bPath)
            return 1;
        return 0;
    }
    return root;
}
;
function _convertComplexRoute(route, parent, root, customData) {
    if (parent === void 0) { parent = null; }
    var newRoute = {
        path: route.path,
        name: route.name,
        component: route.component,
        props: route.props,
        meta: route.meta,
        redirect: route.redirect
    };
    var newCustomData = {
        completePath: concatenatePaths(getPropFromCustomData(customData, 'completePath', ''), newRoute.path)
    };
    if (!newRoute.meta)
        newRoute.meta = {};
    newRoute.meta.parent = parent;
    newRoute.meta.path = newRoute.path;
    newRoute.meta.fullPath = newCustomData.completePath;
    if ((route.meta && route.meta.isRoot) || !parent) {
        root.push(newRoute);
        newRoute.path = newCustomData.completePath;
    }
    else if (parent) {
        if (!parent.children)
            parent.children = [];
        parent.children.push(newRoute);
    }
    var parentAccessRights = parent && parent.meta && parent.meta.accessRights ? parent.meta.accessRights : '';
    if (parentAccessRights)
        newRoute.meta.accessRights = combineAccessRights(newRoute.meta.accessRights, parentAccessRights);
    if (route.children && route.children.length > 0) {
        route.children.forEach(function (childRoute) {
            _convertComplexRoute(childRoute, newRoute, root, newCustomData);
        });
    }
    if (!newRoute.name)
        delete newRoute.name;
    if (!newRoute.component)
        delete newRoute.component;
}
function combineAccessRights(a, b) {
    if (!a)
        a = '';
    if (!b)
        b = '';
    var arrayA = typeof a === 'string' ? a.split(' ') : a;
    var arrayB = typeof b === 'string' ? b.split(' ') : b;
    var finalArray = [];
    arrayA.forEach(function (item) {
        if (!item)
            return;
        if (typeof item === 'string') {
            finalArray.push({
                name: item
            });
        }
        else {
            finalArray.push(item);
        }
    });
    arrayB.forEach(function (item) {
        if (!item)
            return;
        if (typeof item === 'string') {
            finalArray.push({
                name: item
            });
        }
        else {
            finalArray.push(item);
        }
    });
    return finalArray;
}
function getPropFromCustomData(customData, prop, defaultValue) {
    if (defaultValue === void 0) { defaultValue = undefined; }
    if (!customData)
        return defaultValue;
    return customData[prop];
}
function concatenatePaths(pathA, pathB) {
    var hasASlash = pathA.charAt(pathA.length - 1) === '/';
    var hasBSlash = pathB.charAt(0) === '/';
    var slash = '/';
    if (pathA && !pathB)
        slash = '';
    if (hasASlash && !hasBSlash)
        return pathA + pathB;
    if (!hasASlash && hasBSlash)
        return pathA + pathB;
    if (!hasASlash && !hasBSlash)
        return pathA + slash + pathB;
    return pathA + pathB.substring(1);
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/router/helpers/ComplexRoutesConverter.ts
// module id = null
// module chunks = 